import { msrValueApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const MSR_ACTION_TYPE = createNamedActions('msr', {
  GET_MSR: 'GET_MSR',
  CREATE_MSR: 'CREATE_MSR',
  EDIT_MSR: 'EDIT_MSR',
  DELETE_MSR: 'DELETE_MSR',
});

const msrSchema = new schema.Entity('msrValues', {}, { idAttribute: 'id' });

export const getMsrAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await msrValueApi.getValues();

  return dispatch({
    type: MSR_ACTION_TYPE.GET_MSR,
    payload: normalize(data, [msrSchema]).entities.msrValues,
  });
});

export const createMsrAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await msrValueApi.createValue(params);

  return dispatch({
    type: MSR_ACTION_TYPE.CREATE_MSR,
    payload: data,
  });
});

export const editMsrAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await msrValueApi.editValue(params);

  return dispatch({
    type: MSR_ACTION_TYPE.EDIT_MSR,
    payload: data,
  });
});

export const deleteMsrAction = catchAsyncActionError(({ msrValueId }) => async dispatch => {
  await msrValueApi.deleteValue({ msrValueId });

  return dispatch({
    type: MSR_ACTION_TYPE.DELETE_MSR,
    payload: msrValueId,
  });
});
